import { render, staticRenderFns } from "./TaskDetailNavs.vue?vue&type=template&id=75feb526"
import script from "./TaskDetailNavs.vue?vue&type=script&lang=js"
export * from "./TaskDetailNavs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports